import React from "react";
import modal from "../../assets/images/model.jpg";
import { Link } from "react-router-dom";

const MiddleBanner = () => {
  return (
    <section className="hero-container my-4">
      <div className="row g-0 align-items-center hero-inner">
        {/* LEFT IMAGE */}
        <div className="col-md-6">
          <img src={modal} alt="model" className="img-fluid hero-img" />
        </div>

        {/* RIGHT TEXT */}
        <div className="col-md-6 px-5 py-5 hero-content">
          <small className="hero-subtitle">DENIM COLLECTION</small>
          <h1 className="hero-title mt-2">
            The Casual
            <br />
            Selection.
          </h1>
          <p className="hero-desc mt-3">
            Crafted for everyday comfort with a touch of style. Our denim brings
            effortless versatility to your wardrobe— easy to wear, hard to
            replace.
          </p>
          <Link to="/shop" className="hero-link mt-4 d-inline-block">
            Shop Collection →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MiddleBanner;
